import styled from 'styled-components';
import { BUTTON_SECONDARY } from 'components/TCButton/styles';

interface IStyleProps {
  center?: boolean;
  top?: string;
  left?: string;
}

export const MainContainer = styled.div`
    position: absolute;
    top: ${(props: IStyleProps) => (props.top ? props.top : '10px')};
    border-radius: 5px;
    border: solid 1px rgba(189, 189, 189, 0.2);
    background-color: #fff;
    width: 455px;
    max-height: 451px;
    padding: 24px 62px;
    left: ${(props: IStyleProps) => (props.left ? props.left : '0')};
    right:0;
    margin-left: ${(props: IStyleProps) => (props.center ? 'auto' : '160px')};
    margin-right: auto;
`;

export const Tittle = styled.label`
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  color: #000;
  display: block;
  margin-bottom: 30px;
`;

export const ProvidersContainer = styled.div`
    width: 100%;
    display: inline-grid;
    max-height: 228px;
    overflow-y: auto;
    padding: 0px 3px;
    margin-bottom: 25px;
`;

export const Header = styled.div`
  display: flex;
`;

export const SubTittle = styled.div`
  width: 50%;
  font-family: Rubik;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  color: #000;
`;

export const Bottom = styled.div`
  margin-top: 11px;
  display: inline-flex;
  float:right;
  grid-gap: 10px;
  ${BUTTON_SECONDARY}{
    border: none;   
  }
`;

export const ErrorMessage = styled.div`
  font-family: Rubik;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #b7332b;
  min-height: 14px;
  margin-left: 5px;
`;